import { useEffect, useState } from "react";
import { IRestaurantDetail, RestaurantList } from "../models/IRestaurantDetail";
import { getRestaurantById, getRestaurantList } from "../services/restaurant";
import OrdersByDate from "../components/OrdersByDate";

function RestaurantsOrders() {
  const [restaurantList, setRestaurantList] = useState<RestaurantList>();
  const [selectedRestaurantId, setSelectedRestaurantId] = useState<string>("");
  const [selectedRestaurant, setSelectedRestaurant] = useState<IRestaurantDetail>();

  useEffect(() => {
    getRestaurantList().then((response) => {
      if (response.data) setRestaurantList(response.data);
    });
  }, []);

  useEffect(() => {
    if (selectedRestaurantId) {
      getRestaurantById(selectedRestaurantId).then((res) => {
        if (res.data) setSelectedRestaurant(res.data);
      });
    } else {
      setSelectedRestaurant(undefined);
    }
  }, [selectedRestaurantId]);

  return (
    <div className="container py-4" style={{ maxWidth: '1200px' }}>

      {/* Üst alan: select + restoran kartı */}
      <div className="row align-items-center mb-4 g-3">

        {/* Restoran seçici */}
        <div className="col-md-5">
          <label
            className="form-label text-muted small fw-semibold mb-1 text-uppercase"
            style={{ letterSpacing: '0.05em' }}
          >
            <i className="bi bi-building me-1"></i>Restoran
          </label>
          <select
            className="form-select form-select-lg"
            style={{
              borderRadius: '12px',
              border: '1.5px solid #dee2e6',
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
              fontWeight: 500,
            }}
            value={selectedRestaurantId}
            onChange={(evt) => setSelectedRestaurantId(evt.target.value)}
          >
            <option value="" disabled>Restoran seçiniz...</option>
            {restaurantList?.items.map((item) => (
              <option key={item.id} value={item.id}>{item.restourantName}</option>
            ))}
          </select>
        </div>

        {/* Restoran özet kartı */}
        {selectedRestaurant && (
          <div className="col-md-7">
            <div
              className="d-flex align-items-center p-3 rounded-3"
              style={{
                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                border: '1.5px solid #e9ecef',
                boxShadow: '0 4px 16px rgba(0,0,0,0.07)',
              }}
            >
              <img
                src={"https://mutfacik.s3.eu-central-1.amazonaws.com/" + selectedRestaurant.restourantLogoPath}
                style={{
                  width: '68px', height: '68px',
                  objectFit: 'cover',
                  borderRadius: '14px',
                  border: '2px solid #fff',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.14)',
                  flexShrink: 0,
                }}
                alt={selectedRestaurant.restourantName}
              />
              <div className="ms-3">
                <h5 className="mb-1 fw-bold" style={{ fontSize: '1.1rem' }}>
                  {selectedRestaurant.restourantName}
                </h5>
                <div className="d-flex gap-2 flex-wrap mt-1">
                  {selectedRestaurant.restourantIsEnabled ? (
                    <span
                      className="badge"
                      style={{ background: '#dcfce7', color: '#166534', fontSize: '0.72rem', borderRadius: '20px', padding: '4px 10px' }}
                    >
                      <i className="bi bi-door-open-fill me-1"></i>Acik
                    </span>
                  ) : (
                    <span
                      className="badge"
                      style={{ background: '#fee2e2', color: '#991b1b', fontSize: '0.72rem', borderRadius: '20px', padding: '4px 10px' }}
                    >
                      <i className="bi bi-door-closed-fill me-1"></i>Kapali
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Sipariş listesi */}
      {selectedRestaurantId ? (
        <OrdersByDate restaurantId={selectedRestaurantId} />
      ) : (
        <div className="text-center py-5 text-muted">
          <i className="bi bi-building" style={{ fontSize: '2.5rem', opacity: 0.3 }}></i>
          <div className="mt-2 small">Siparişleri görüntülemek için bir restoran seçin.</div>
        </div>
      )}
    </div>
  );
}

export default RestaurantsOrders;